import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { DashboardIconBirthdayCake, DashboardIconPersons } from '../../common/icons'
import { LoadingContainer } from '../../common/loaders/loadingcontainer'
import { average, localized } from '../../common/utils'

function calculateAgeFromSocSec(socSec) {
	if (!socSec) return null
	const match = socSec.match(/^(\d{2})(\d{2})(\d{2})/)
	if (!match) return null

	const day = parseInt(match[1], 10)
	const month = parseInt(match[2], 10)
	let year = parseInt(match[3], 10)

	const currentYear = new Date().getFullYear() % 100
	year += year <= currentYear ? 2000 : 1900

	const birthDate = new Date(year, month - 1, day)
	if (Number.isNaN(birthDate.valueOf())) return null

	const today = new Date()
	let age = today.getFullYear() - birthDate.getFullYear()
	const m = today.getMonth() - birthDate.getMonth()
	if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--
	return age
}

export function PersonnelSummary({ persons }) {
	const { t } = useTranslation()
	let summary

	if (!persons?.length) {
		summary = { total: 0, averageAge: '-', male: 0, female: 0 }
	} else {
		const today = new Date()

		const activePersons = persons.filter((p) => {
			const endDate = p.employmentDetails?.endDate
			const startDate = p.employmentDetails?.startDate

			const hasNotEnded = !endDate

			const hasStarted = !startDate || new Date(startDate) <= today

			return hasNotEnded && hasStarted
		})

		//const activePersons = persons.filter(p => !p.employmentDetails?.endDate);
		const total = activePersons.length

		const genderPersons = activePersons.filter((p) => p.socSec)
		const male = genderPersons.filter((p) => (p.gender || '').trim().toUpperCase() === 'M').length
		const female = genderPersons.filter((p) => (p.gender || '').trim().toUpperCase() === 'N').length

		const ages = genderPersons.map((p) => calculateAgeFromSocSec(p.socSec)).filter((age) => age !== null)
		const averageAge = ages.length > 0 ? localized.numberFormat.format(average(ages).toFixed(1)) : '-'

		summary = { total, averageAge, male, female }
	}

	return summary ? (
		<>
			<h4 style={{ color: 'var(--heeros-blue)', marginBottom: '15px' }}>
				{t('PersonnelSummary', 'Henkilöstöyhteenveto')}
			</h4>
			<Row className="text-center mt-4">
				<Col>
					<div style={{ fill: '#20C6A1' }}>
						<DashboardIconPersons width="112" height="92" />
					</div>
					<div>{t('PersonnelTotal', 'Henkilöstömäärä')}</div>
					<h2>{summary.total}</h2>
				</Col>
				<Col>
					<DashboardIconBirthdayCake />
					<div>{t('AverageAge', 'Keski-ikä')}</div>
					<h2>{summary.averageAge}</h2>
				</Col>
			</Row>
		</>
	) : (
		<LoadingContainer />
	)
}
